export default __webpack_public_path__ + "static/media/mercury.969c619f.png";